const humanizeDuration = require("humanize-duration");

export const humanize: (time: number) => string = humanizeDuration.humanizer({
  language: process.env.REACT_APP_LANGUAGE,
  units: ["d", "h", "m"],
  round: true,
});
